const baseURLObj = {
    
    baseUrl: "https://supplylink-api.zestdent.com"
};
    
export default baseURLObj